export default "__VITE_ASSET__ClOkxuZ5__"